import BaseLocaleListener from './BaseLocaleListener';

export default {
    connect: BaseLocaleListener.connect,
};
